<template>
  <div id="memorial-index">
    <b-col>
      <h1 class="title">{{ $t('pages.memorial.search_result') }}</h1>
    </b-col>
    <e-index
      :uri="getUri()"
      :order-call-back="orderCallBack"
      :can-create="false"
      name="memorial"
    >
      <div slot="list-content" slot-scope="ctx">
        <b-row align-v="center">
          <b-col class="profile-pic-block" sm="3" md="2">
            <profile-picture :item="ctx.item" />
          </b-col>
          <b-col class="profile-info" sm="6" md="7">
            <span class="red-text step-title">
              {{ ctx.item.first_name }} {{ ctx.item.last_name }}
              <span v-if="state(ctx.item)"> {{ $t('pages.memorial.disabled') }}</span>
            </span>
            <p>{{ ctx.item.birth_date | moment('LL') }} - {{ ctx.item.death_date | moment('LL') }}</p>
          </b-col>
          <b-col>
            <b-button
              :to="{ name: 'memorial.show', params: { id: encodeURIComponent(ctx.item.unique_key) } }"
              variant="primary"
              block
            >
              {{ $t('actions.see_memo') }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </e-index>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import ProfilePicture from '@/components/ProfilePicture';

  export default {
    name: 'MemorialIndex',
    components: {
      EIndex,
      ProfilePicture,
    },
    props: {
      search: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        orderCallBack(collection) {
          return _.orderBy(collection, ['first_name'], ['asc']);
        },
      };
    },
    methods: {
      state(entity) {
        return !entity.enabled;
      },
      getUri() {
        return `api/public/search/?search=${this.search}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  /deep/ .profile-pic-block {
    .profile-pic-container {
      .profile-pic {
        width: 100px !important;
        height: 100px !important;
      }

      a {
        position: absolute;
        left: 110%;
        bottom: 0;
        max-width: none;
        width: 250%;
      }
    }
  }

  .list-group .list-group-item {
    .profile-info {
      margin-bottom: 24px;
    }

    .step-title {
      margin-bottom: 0 !important;
      font-size: 1.5rem;
    }

    p {
      margin: 0 !important;
    }
  }
  @include editable-max-width(992px) {
    /deep/ .profile-pic-block {
      .profile-pic-container {
        a {
          left: 113%;
        }
      }
    }

    .list-group .list-group-item {
      .profile-info {
        margin-bottom: 48px;
      }
    }
  }
  @include editable-max-width(575px) {
    /deep/ .profile-pic-block {
      .profile-pic-container {
        a {
          left: auto;
          top: 162px;
          max-width: 100%;
          width: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Memorial/index.vue